module.exports = __webpack_public_path__ + "static/media/lahitapiola.676f7f46.png";